import { createSelector } from "reselect";
import { createAction } from "redux-actions";
import { path, union, isEmpty } from "ramda";

import { documentsToDictionary, absolutePageToRelative } from "~/utils";

export const ADD_DLS_USER_MATERIAL = "USER@DLS_USER_MATERIAL::ADD";
export const ADD_DLS_USER_MATERIAL_MULTIPLE =
  "USER@DLS_USER_MATERIAL::ADD_MULTIPLE";
export const UPDATE_DLS_USER_MATERIAL = "USER@DLS_USER_MATERIAL::UPDATE";
export const REMOVE_DLS_USER_MATERIAL = "USER@DLS_USER_MATERIAL::REMOVE";

export const addMaterial = createAction(ADD_DLS_USER_MATERIAL);

export const addAllDlsUserMaterials = createAction(
  ADD_DLS_USER_MATERIAL_MULTIPLE
);
export const updateDlsUserMaterial = createAction(UPDATE_DLS_USER_MATERIAL);

export const removeDlsUserMaterial = createAction(REMOVE_DLS_USER_MATERIAL);

const getDlsUserMaterials = path(["user", "dlsUserMaterials"]);

export const selectDlsUserMaterials = createSelector(
  getDlsUserMaterials,
  materials => {
    const materialsWithCategory = materials.map(material => {
      const category = {
        isStatic: true,
        kind: "custom_materials",
        title: "Eigene Materialien",
        type: isEmpty(material.pages) ? "book" : "page",
        view: "list",
        pages: material.pages.map(page => absolutePageToRelative(page))
      };

      return {
        ...material,
        categories: [category],
        availableForPresentationmode:
          material.availableForPresentationmode || true,
        listIcon: "link"
      };
    });

    return documentsToDictionary(materialsWithCategory);
  }
);

const initialState = () => [];

export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case ADD_DLS_USER_MATERIAL:
      return [...state, action.payload];
    case ADD_DLS_USER_MATERIAL_MULTIPLE:
      return union(state, action.payload);
    case UPDATE_DLS_USER_MATERIAL:
      return state.map(material => {
        if (action.payload._id === material._id) {
          return {
            ...material,
            title: action.payload.title,
            sourcePath: action.payload.sourcePath,
            linkText: action.payload.linkText,
            shortDescription: action.payload.shortDescription,
            _rev: action.payload._rev || material._rev
          };
        } else {
          return material;
        }
      });
    case REMOVE_DLS_USER_MATERIAL:
      return state.filter(material => material._id !== action.payload);
    default:
      return state;
  }
}
